<template>
  <div>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo registro</v-btn>
          </template>
          <enrollment-admin-register
          :course="course"
          :registration_id="registration_id"
          :modal_open="dialog"
          v-on:closeModal="dialog = false"
          v-on:updateDetail="$emit('updateDetail')"
          ></enrollment-admin-register>
      </v-dialog>
    </v-toolbar>
    <v-card>
      <v-card-title>
        Estudiantes registrados
        <v-spacer></v-spacer>
        <v-layout row wrap justify-end>
          <v-flex xs5 px-1>
            <v-text-field
              v-model="search_filter"
              append-icon="search"
              :label="$t('extracurriculares.register.search')"
              clearable
            ></v-text-field>
          </v-flex>
          <v-flex xs3 px-1>
            <v-select
              v-model="status_filter"
              :items="register_status_filter"
              :label="$t('extracurriculares.courses.form.status')"
              clearable
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="students_to_show"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.student ? props.item.student.family_id : '' }}</td>
          <td class="text-xs-center">{{ props.item.student ? props.item.student.student_number : props.item.student_ext.nit }}</td>
          <td class="text-xs-center">{{ props.item.student ? props.item.student.full_name : props.item.student_ext.full_name }}</td>
          <td class="text-xs-center">{{ props.item.schedule.name }}</td>
          <td class="text-xs-center">{{ props.item.created_at }}</td>
          <td class="text-xs-center">{{ $t(`reports.general.status.${props.item.status}`) }}</td>
          <td class="text-xs-center">
            <span v-if="props.item.enrollment && props.item.enrollment.student_status === 'CANCELED'" class='error white--text pa-2'>Cancelado</span>
            <span v-if="props.item.enrollment && props.item.enrollment.student_status === 'APPROVED'" class='success white--text pa-2'>Aprobado</span>
            <span v-if="props.item.enrollment && props.item.enrollment.student_status === 'ENROLLED'" class='info white--text pa-2'>matriculado</span>
          </td>
          <td class="text-xs-center">
            <v-btn
              :loading="loading_btn > 0"
              :disabled="loading_btn > 0"
              @click="openUpdateDialog(props.item)"
              color="primary">
              Actualizar registro
            </v-btn>
            <v-btn
              :loading="loading_btn > 0"
              :disabled="loading_btn > 0"
              @click="openClothesDetail(props.item.student ? props.item.student.id : 0)"
              color="info">
              Uniformes
            </v-btn>
            <v-btn
              :loading="loading_btn > 0"
              :disabled="loading_btn > 0"
              outline
              @click="getStudentMovesDetail(props.item.student ? props.item.student.id : 0)"
              color="primary">
              Detalle
            </v-btn>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="update_dialog" max-width="500px">
      <v-card>
          <v-card-title>
              <span v-if="register_in_edition.student" class="headline">
                {{ register_in_edition.student.full_name }} - {{ register_in_edition.student.grade_level }}°
              </span>
          </v-card-title>
          <v-card-title>
              <span class="headline">Actualizar registro</span>
          </v-card-title>

          <v-card-text>
            <v-autocomplete
              :form="form"
              v-model="form.course_id"
              :loading="loading_course"
              :items="courses"
              :search-input.sync="search_course"
              cache-items
              hide-no-data
              label="Course"
              v-validate="'required'"
              data-vv-name="course_id"
              :error-messages="errors.collect('course_id')"
              name="course_id"
              @change="validateCourseRequirements"
              :disabled="(form.status !== register_in_edition.status || register_in_edition.enrollment && form.student_status != register_in_edition.enrollment.student_status)"
            ></v-autocomplete>


            <div v-if="studentRestrictions[register_in_edition.student_id] && !studentRestrictions[register_in_edition.student_id].available">
              <v-alert
                :value="true"
                type="warning"
                outline
              >
                <ul>
                  <li
                    v-if="studentRestrictions[register_in_edition.student_id] && studentRestrictions[register_in_edition.student_id].grade"
                  >
                    {{ $t('extracurriculares.register.available_courses.grade_requirement') }}
                  </li>

                  <li
                    v-if="studentRestrictions[register_in_edition.student_id] && studentRestrictions[register_in_edition.student_id].age"
                  >
                    {{ $t('extracurriculares.register.available_courses.age_requirement') }}
                  </li>
                  <li
                    v-if="studentRestrictions[register_in_edition.student_id] && studentRestrictions[register_in_edition.student_id].prerequisite"
                  >
                    {{ $t('extracurriculares.register.available_courses.course_requirement') }}
                  </li>
                  <li
                    v-if="shcedulesValidations[register_in_edition.student_id]"
                  >
                    {{ $t('extracurriculares.register.available_courses.schedule_requirement') }}
                  </li>
                </ul>
              </v-alert>
            </div>

            <v-select
              :items="course_schedules"
              label="Horario"
              :v-errors="errors"
              v-model="form.schedule_id"
              name="schedule_id"
              v-validate="'required'"
              @change="validateSchedules"
              :disabled="
                (form.status !== register_in_edition.status || register_in_edition.enrollment && form.student_status != register_in_edition.enrollment.student_status) ||
                (studentRestrictions[register_in_edition.student_id] && !studentRestrictions[register_in_edition.student_id].available)
                "
            ></v-select>

            <div v-if="shcedulesValidations[form.schedule_id]">
              <v-alert
                :value="true"
                type="warning"
                outline
              >
                <ul>
                  <li
                    v-if="shcedulesValidations[form.schedule_id]"
                  >
                    {{ $t('extracurriculares.register.available_courses.schedule_requirement') }}
                  </li>
                </ul>
              </v-alert>
            </div>

            <v-select
              :items="register_status"
              label="Estado reserva"
              :v-errors="errors"
              v-model="form.status"
              name="status"
              v-validate="'required'"
              :disabled="form.course_id != register_in_edition.course_id || form.schedule_id != register_in_edition.schedule_id"
            ></v-select>

            <v-select
              :items="students_status.filter(status => {
                if (this.form.status >= 1) {
                  if (status.value == 'ENROLLED' || status.value == 'APPROVED') {
                    return true;
                  }
                } else {
                  if (status.value == 'CANCELED') {
                    return true;
                  }
                }
              })"
              label="Estado matricula"
              :v-errors="errors"
              v-model="form.student_status"
              name="student_status"
              v-validate="'required'"
              :disabled="
                form.course_id != register_in_edition.course_id || form.schedule_id != register_in_edition.schedule_id  ||
                form.status == 0 || form.status == -3
                "
            ></v-select>

            <v-textarea
              outline
              label="Motivo"
              name="reason"
              v-model="form.reason"
              v-validate.disable="'required'"
              data-vv-name="reason"
              :error-messages="errors.collect('reason')"
            ></v-textarea>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="update_dialog = false">Cancelar</v-btn>
              <v-btn
                :disabled="studentRestrictions[register_in_edition.student_id] && !studentRestrictions[register_in_edition.student_id].available || shcedulesValidations[form.schedule_id]"
                color="blue darken-1"
                flat
                @click="updateCourseRegister">Actualizar</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
  <v-dialog
    v-model="student_details_dialog"
    max-width="auto"
    transition="dialog-transition"
  >
    <v-card>
      <v-data-table
        :headers="student_headers"
        :items="student_details"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.old_reserve.course.name }}</td>
          <td class="text-xs-center">{{ props.item.old_reserve.schedule ? props.item.old_reserve.schedule.name : '' }}</td>
          <td class="text-xs-center">{{ $t(`reports.general.status.${props.item.old_reserve.status}`) }}</td>
          <td class="text-xs-center">{{ props.item.new_reserve.course.name }}</td>
          <td class="text-xs-center">{{ props.item.new_reserve.schedule ? props.item.new_reserve.schedule.name : '' }}</td>
          <td class="text-xs-center">{{ $t(`reports.general.status.${props.item.new_reserve.status}`) }}</td>
          <td class="text-xs-center">{{ props.item.user.name }}</td>
          <td class="text-xs-center">{{ props.item.reason }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
  <v-dialog
        v-model="course_clothes_dialog"
        width="750"
        persistent
      >
      <course-clothes
        :course_clothes="courses_clothes"
        v-on:refreshClothes="refreshClothes"
      >
      </course-clothes>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="course_clothes_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import Form from 'vform'
  import enrollmentAdminRegister from './enrollment_register.vue'
  import courseClothes from './../enrollment/course_clothes'
  export default {
    name: 'enrollment-registration-students-view',
    components: {
      'enrollment-admin-register': enrollmentAdminRegister,
      'course-clothes': courseClothes,
    },
    props: {
      students_registered: {
        type: Array,
        required: true
      },
      course: {
        type: Object,
        required: true
      },
      registration_id: {
        type: Number,
      }
    },
    data() {
      return {
        dialog: false,
        search_filter: '',
        status_filter: '',
        students_to_show: this.$props.students_registered,
        headers: [
          { text: 'Id familia', value: 'student.family_id', align: 'center' },
          { text: 'Id estudiante', value: 'student.student_number', align: 'center' },
          { text: 'Estudiante', value: 'student.full_name', align: 'center' },
          { text: 'Horario', value: 'schedule.name', align: 'center' },
          { text: 'Fecha de registro', value: 'created_at', align: 'center' },
          { text: 'Estado reserva', value: 'status', align: 'center' },
          { text: 'Estado estudiante', value: 'status', align: 'center' },
          { text: 'Acciones', value: 'protein', align: 'center' },
        ],
        courses: [],
        courses_data: [],
        registration_ids: [],
        update_dialog: false,
        form: new Form({
          reservation_id: '',
          id: '',
          course_id: '',
          schedule_id: '',
          status: '',
          student_status: '',
          course_register_dates_id: 0,
          reason: ''
        }),
        course_schedules: [],
        register_status: [
          { value: -3, text: 'Cancelado admin' },
          { value: -2, text: 'Cancelado familia', disabled: true },
          { value: -1, text: 'Cancelado automatico', disabled: true },
          { value: 0, text: 'Reservado' },
          { value: 1, text: 'Pagado' },
          { value: 2, text: 'Pagado factura cargada', disabled: true },
          { value: 3, text: 'Pagado pago cargado', disabled: true },
        ],
        register_status_filter: [
          { value: -3, text: 'Cancelado admin' },
          { value: -2, text: 'Cancelado familia' },
          { value: -1, text: 'Cancelado automatico' },
          { value: 0, text: 'Reservado' },
          { value: 1, text: 'Pagado' },
          { value: 2, text: 'Pagado factura cargada' },
          { value: 3, text: 'Pagado pago cargado' },
        ],
        students_status: [
          { value: 'CANCELED', text: 'Cancelado' },
          { value: 'ENROLLED', text: 'Matriculado' },
          { value: 'APPROVED', text: 'Curso aprobado' },
        ],
        loading_course: false,
        search_course: null,
        loading_btn: 0,
        register_in_edition: {},
        studentRestrictions: {},
        shcedulesValidations: {},
        student_details_dialog: false,
        student_headers: [
          { text: 'Curso ant', value: 'old_reserve.course.name', align: 'center' },
          { text: 'Horario ant', value: 'old_reserve.schedule.name', align: 'center' },
          { text: 'Estado ant', value: 'old_reserve.status', align: 'center' },
          { text: 'Curso nuev', value: 'new_reserve.course.name', align: 'center' },
          { text: 'Horario nuev', value: 'new_reserve.schedule.name', align: 'center' },
          { text: 'Estado nuev', value: 'new_reserve.status', align: 'center' },
          { text: 'Usuario', value: 'user.name', align: 'center' },
          { text: 'Motivo', value: 'reason', align: 'center' },
        ],
        student_details: [],
        courses_clothes: [],
        course_clothes_dialog: false,
        course_clothes_student: ''
      }
    },
    watch: {
      students_registered: function(newVal, oldVal) {
        this.filter_students()
      },
      search_filter() {
        this.filter_students()
      },
      status_filter() {
        this.filter_students()
      },
      form: {
        handler: function(newVal) {
          this.course_schedules = []
          this.courses_data.find(course => course.id === newVal.course_id)
            .active_schedules.forEach(schedule => {
              this.course_schedules.push({ value: schedule.id, text: schedule.name })
            })

          const register_id = this.registration_ids.find(registration => registration.course_id == newVal.course_id)

          if (register_id) {
            this.form.course_register_dates_id = register_id.registration_id
          }


          if (newVal.status == 0 || newVal.status == -3) {
            this.form.student_status = 'CANCELED'
          }
        },
        deep: true
      },
      search_course (val) {
        val && val !== this.courses && this.queryCourses(val)
      },
      course_clothes_dialog(newValue, oldValue) {
        if (oldValue && !newValue) {

          this.$emit('updateDetail')
          this.course_clothes_student = ''
        }
      }
    },
    methods: {
      filter_students() {
        let students_to_show = this.$props.students_registered

        if (this.search_filter && this.search_filter.trim() !== '') {
          students_to_show = students_to_show
            .filter(course => course.student.full_name.toUpperCase().indexOf(this.search_filter.toUpperCase()) > -1)
        }

        if ((this.status_filter && this.status_filter !== '') || this.status_filter === 0) {
          students_to_show = students_to_show.filter(course => course.status === this.status_filter)
        }

        this.students_to_show = students_to_show
      },
      queryCourses (v) {
        this.loading_course = true
        this.courses = this.courses.filter(e => {
          return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading_course = false
      },
      async getAvailableCourses() {
        this.courses = []
        await axios.get('/api/extracurriculares/admin/courses_available')
          .then(resp => {
            if (resp.status === 200) {
              const { data } = resp;
              if (!data.available_courses) {
                return
              }
              this.courses_data = data.courses
              this.registration_ids = data.registration_ids
            }
          })
          .catch(error => {

          })
      },
      async openUpdateDialog(register) {
        this.register_in_edition = register
        this.loading_btn = register.id
        let available = false
        await this.getAvailableCourses()
        const course_type = this.courses_data.find(course => course.id === register.course_id).course_type.id
        this.courses = [];
        this.courses_data
          .filter(course => course.course_type.id === course_type)
          .filter(course => {
            available = false
            if (course.exclusion_type === 'grade' && course.grades) {
              available = course.grades
                .split(', ')
                .includes(register.student.grade_level)
            }
            if (course.exclusion_type === 'next_grade' && course.grades) {
              available = course.grades
                .split(', ')
                .includes(register.student.next_grade)
            }

            if (course.exclusion_type === 'age' && course.ages) {
              const ages = course.ages
                .split(' - ')
                .map(age => parseInt(age, 10))
                available = register.student.age >= ages[0] && register.student.age <= ages[1]
            }

            return available
          })
          .forEach(course => {
            this.courses.push({ value: course.id, text: course.name })
          })

        const id = register.enrollment ? register.enrollment.id : null
        const reservation_id = register.id
        const course_id = register.course_id
        const schedule_id = register.schedule_id
        const status = register.status
        const student_status = register.enrollment ? register.enrollment.student_status : null
        const course_register_dates_id = register.course_register_dates_id

        this.form = new Form({
          id,
          reservation_id,
          course_id,
          schedule_id,
          status,
          student_status,
          course_register_dates_id,
          reason: ''
        })
        this.loading_btn = 0
        this.update_dialog = true
      },
      updateCourseRegister() {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.form.put('/api/extracurriculares/admin/register',)
              .then(resp => {
                if (resp.status === 200) {

                  if (resp.data.no_days_to_pay == true) {
                    this.$store.dispatch('responseMessage', {
                      type: 'warning',
                      text: 'El curso no tiene fechas de inscripción activas para relacionar esta reserva.',
                      modal: false
                    })
                    return;
                  }

                  if (resp.data.student_enrolled) {
                    this.$store.dispatch('responseMessage', {
                      type: 'warning',
                      text: 'El estudiante tiene un registro activo a este curso',
                      modal: false
                    })
                    return;
                  }

                  this.$store.dispatch('responseMessage', {
                      type: 'success',
                      text: 'Actualizado correctamente',
                      modal: false
                  })
                  this.update_dialog = false
                  this.$emit('updateDetail')
                }
              })
              .catch(error => {
                console.log(error)
              })
          }
        })
      },
      validateCourseRequirements() {
        this.studentRestrictions = {};
        const course_id = this.form.course_id
        const course = this.courses_data.find(course => course.id === course_id)
        const student = this.$props.students_registered.find(register => register.student_id === this.register_in_edition.student_id).student

        let available = false;
        let grade = false;
        let age = false;
        let prerequisite = false

        if (course.grades) {
          available = course.grades
            .split(', ')
            .includes(student.grade_level)
            grade = !available
        }

        if (course.ages) {
          const ages = course.ages
            .split(' - ')
            .map(age => parseInt(age, 10))
          available = student.age >= ages[0] && student.age <= ages[1]
          age = !available
        }

        if (course.prerequisite_id) {
          const prerequisite_approved = student.approved_courses &&
            student.approved_courses.filter(course => course.course_id === course.prerequisite_id).length > 0

          available = prerequisite_approved
          prerequisite = !prerequisite_approved
        }

        this.studentRestrictions[student.id] = {
          available,
          grade,
          age,
          prerequisite
        }


      },
      validateSchedules() {
        this.shcedulesValidations = {};
        const old_schedule_id = this.register_in_edition.schedule_id
        const schedule_id = this.form.schedule_id
        const course_id = this.form.course_id
        const course = this.courses_data.find(course => course.id === course_id)
        const student = this.$props.students_registered.find(register => register.student_id === this.register_in_edition.student_id).student

        const schedule_to_validate_details = course
          .active_schedules
          .find(schedule => schedule.id === schedule_id)
          .details

        student
        .active_reservations
        .forEach(reservation => {
          reservation.schedule.details
            .filter(detail => detail.schedule_id !== old_schedule_id)
            .forEach(reservation_detail => {
            schedule_to_validate_details.filter(schedule_to_validate => schedule_to_validate.day === reservation_detail.day)
              .forEach(validation_detail => {
                if (
                    ((Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) >= Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) &&
                      Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) <= Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`))
                    ||
                    (Date.parse(`1990-01-01 ${validation_detail.time_to}:00`) >= Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) &&
                      Date.parse(`1990-01-01 ${validation_detail.time_to}:00`) <= Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`)))
                    ||
                    (Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) >= Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) &&
                      Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) <= Date.parse(`1990-01-01 ${validation_detail.time_to}:00`))
                    ||
                    (Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`) >= Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) &&
                      Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`) <= Date.parse(`1990-01-01 ${validation_detail.time_to}:00`))
                  ) {
                    this.shcedulesValidations[validation_detail.schedule_id] = true
                  }
              })
          })
        });

      },
      getStudentMovesDetail(student_id) {
        axios.get(`/api/extracurriculares/admin/enrollment/details/student/${student_id}`)
          .then(resp => {
            if (resp.status === 200) {
              this.student_details_dialog = true
              this.student_details = resp.data.details
            }
          })
          .catch(error => console.log(error))
      },
      openClothesDetail(student_id) {
        this.loading_btn = student_id
        const courses = this.students_registered
          .filter(register => register.student_id === student_id)
          this.course_clothes_student = student_id
          this.courses_clothes = courses
          this.course_clothes_dialog = true
          this.loading_btn = 0
      },
      refreshClothes() {

      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/admin/enrollment_registration_students.vue